import script from "./HallPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HallPage.vue?vue&type=script&setup=true&lang=js"

import "./HallPage.vue?vue&type=style&index=0&id=2386cac7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2386cac7"]])

export default __exports__